/**
 * Animation légère d'un compteur numérique (chiffres clés). Le compte à
 * rebours se déclenche quand l'élément entre dans le viewport, une seule fois.
 * Respecte prefers-reduced-motion : la valeur finale est affichée directement.
 *
 * Usage : <span data-count="26">26</span>
 */

const DURATION_MS = 1100;

function animateCount(el: HTMLElement, target: number): void {
  const start = performance.now();

  function tick(now: number): void {
    const progress = Math.min((now - start) / DURATION_MS, 1);
    // easeOutCubic pour un ralenti sobre en fin d'animation.
    const eased = 1 - Math.pow(1 - progress, 3);
    el.textContent = Math.round(eased * target).toLocaleString('fr-FR');
    if (progress < 1) {
      requestAnimationFrame(tick);
    } else {
      el.textContent = target.toLocaleString('fr-FR');
    }
  }

  requestAnimationFrame(tick);
}

export function initCounters(): void {
  const counters = document.querySelectorAll<HTMLElement>('[data-count]');
  if (counters.length === 0) {
    return;
  }

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
        const el = entry.target as HTMLElement;
        const target = Number.parseInt(el.dataset.count ?? '', 10);
        if (!Number.isNaN(target)) {
          animateCount(el, target);
        }
        obs.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );

  counters.forEach((el) => observer.observe(el));
}
